import React from 'react';

import { StoreBodyBlock } from 'constants/enums';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';
import {
  ETemplateStudioSidebarBlock,
  TemplateStudioBlock
} from 'state/template-studio.state.service';

import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

export const TemplateStudioTriggeredPopupsForm: React.FC = () => {
  const { setOpenSecondarySidebarBlock, openSecondarySidebarBlock } =
    useTemplateStudioState();

  const toggleSecondarySidebar = (block: TemplateStudioBlock): void => {
    setOpenSecondarySidebarBlock(undefined);
    if (openSecondarySidebarBlock !== block) {
      setTimeout(() => {
        setOpenSecondarySidebarBlock(block);
      }, 100);
    }
  };

  const handleWidgetClick = (): void => {
    toggleSecondarySidebar(StoreBodyBlock.triggeredPopups);
  };

  const handlePopupClick = (): void => {
    toggleSecondarySidebar(ETemplateStudioSidebarBlock.TRIGGERED_POPUPS_POPUP);
  };

  return (
    <div className="flex gap-2 mt-2 justify-between">
      <div className="text-sm">Element Type</div>
      <Tabs defaultValue="badge" orientation="vertical">
        <TabsList className="flex-col bg-base-muted h-[76px]">
          <TabsTrigger
            value="badge"
            onClick={handleWidgetClick}
            className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
          >
            Badge
          </TabsTrigger>
          <TabsTrigger
            value="popup"
            onClick={handlePopupClick}
            className="h-[34px] w-[120px] data-[state=active]:bg-base-background data-[state=active]:text-indigo-500 text-base-mutedForeground"
          >
            Popup
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};
